import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$entries2 from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useRef, useEffect } from "react";
import { Typography, RaiseColors, useTheme, Select } from "componentLibrary";
import { OrganizationDateRangeFilterEnum } from "utils/Enums";
import { LowestResolutionBasedOnDateRange, CalculateMinMaxDate } from "client/WorkplaceOS/Analytics/WorkplaceOSHelper";
import useWindowSize from "hooks/useWindowSize";
import FieldBase from "componentLibrary/Fields/FieldBase";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DateRangeFilterButton = function DateRangeFilterButton(_ref) {
  var _windowSize$innerWidt, _Object$entries;
  var selectedDateRangeFilter = _ref.selectedDateRangeFilter,
    onSelectedDateRangeFilterChanged = _ref.onSelectedDateRangeFilterChanged,
    label = _ref.label,
    defaultInputText = _ref.defaultInputText;
  var theme = useTheme();
  var windowSize = useWindowSize();
  var windowWidth = (_windowSize$innerWidt = windowSize === null || windowSize === void 0 ? void 0 : windowSize.innerWidth) !== null && _windowSize$innerWidt !== void 0 ? _windowSize$innerWidt : 0;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    containerWidth = _React$useState4[0],
    setContainerWidth = _React$useState4[1];
  var menuRef = useRef();
  var onClickOutsideHandler = function onClickOutsideHandler(e) {
    var _menuRef$current;
    if (!(menuRef !== null && menuRef !== void 0 && (_menuRef$current = menuRef.current) !== null && _menuRef$current !== void 0 && _menuRef$current.contains(e.target))) {
      setAnchorEl(null);
    }
  };
  useEffect(function () {
    //instantiates the component to handle resizes, and click events outside to close.
    var handleResize = function handleResize() {
      var _document$getElementB, _document$getElementB2;
      var totalButtonWidth = (_document$getElementB = (_document$getElementB2 = document.getElementById("dateRangeFilterButton")) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.clientWidth) !== null && _document$getElementB !== void 0 ? _document$getElementB : 0;
      setContainerWidth(totalButtonWidth);
    };
    document.addEventListener("mousedown", onClickOutsideHandler);
    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      document.removeEventListener("mousedown", onClickOutsideHandler);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  var onClickButton = function onClickButton(filterType) {
    return function () {
      var minMaxDates = CalculateMinMaxDate(filterType);
      onSelectedDateRangeFilterChanged(filterType, minMaxDates.minDate, minMaxDates.maxDate, LowestResolutionBasedOnDateRange(filterType));
    };
  };
  var DateRangeFormGroups = (_Object$entries = _Object$entries2(_valuesInstanceProperty(OrganizationDateRangeFilterEnum))) === null || _Object$entries === void 0 ? void 0 : _mapInstanceProperty(_Object$entries).call(_Object$entries, function (object, index) {
    var _context;
    var _object = _slicedToArray(object, 2),
      key = _object[0],
      values = _object[1];
    var selected = selectedDateRangeFilter === key;
    return /*#__PURE__*/_jsxs("div", {
      style: {
        padding: "8px 0px",
        display: "flex",
        justifyContent: "space-between",
        cursor: "pointer"
      },
      onClick: onClickButton(key),
      children: [/*#__PURE__*/_jsx(Typography, {
        color: selected ? RaiseColors.blue500 : RaiseColors.midnight,
        weight: "medium",
        variant: "paragraph_medium",
        children: values.label
      }), /*#__PURE__*/_jsx(Typography, {
        weight: "regular",
        variant: "paragraph_small",
        style: {
          whiteSpace: "normal"
        },
        color: selected ? RaiseColors.blue500 : RaiseColors.midnight,
        children: _concatInstanceProperty(_context = "".concat(CalculateMinMaxDate(key).minDate.format("MMM D"), " - ")).call(_context, CalculateMinMaxDate(key).maxDate.format("MMM D, YYYY"))
      })]
    }, index);
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_small",
      weight: "medium",
      style: {
        marginBottom: "8px"
      },
      component: "div",
      children: label
    }), /*#__PURE__*/_jsx(FieldBase, {
      fullWidth: true,
      InputLabelProps: {
        style: {
          position: "static"
        }
      },
      children: /*#__PURE__*/_jsx(Select, {
        style: {
          height: "100%",
          textAlign: "left",
          backgroundColor: RaiseColors.white,
          border: "none",
          borderRadius: "8px"
        },
        MenuProps: {
          disablePortal: true,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
          },
          PaperProps: {
            onMouseDown: function onMouseDown(event) {
              event.preventDefault();
            },
            style: {
              borderRadius: "16px",
              marginTop: "8px"
            }
          },
          keepMounted: true
        },
        displayEmpty: true,
        value: selectedDateRangeFilter,
        onChange: function onChange() {},
        renderValue: function renderValue() {
          var _OrganizationDateRang;
          return /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_small",
            color: RaiseColors.jllNeutral900,
            children: OrganizationDateRangeFilterEnum === null || OrganizationDateRangeFilterEnum === void 0 || (_OrganizationDateRang = _valuesInstanceProperty(OrganizationDateRangeFilterEnum)[selectedDateRangeFilter]) === null || _OrganizationDateRang === void 0 ? void 0 : _OrganizationDateRang.label
          });
        },
        children: /*#__PURE__*/_jsx("div", {
          style: {
            margin: "8px 16px"
          },
          children: DateRangeFormGroups
        })
      })
    })]
  });
};
export default DateRangeFilterButton;